import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  input,
  output,
  TemplateRef,
} from '@angular/core';
import { FieldTree } from '@angular/forms/signals';
import { Checkbox, CheckboxSignalComponent } from './checkbox/checkbox-signal.component';
import { NgClass, NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'shared-ui-checkbox-group',
  imports: [NgTemplateOutlet, CheckboxSignalComponent, NgClass],
  templateUrl: './checkbox-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxGroupComponent<T> {
  constructor() {
    effect(() => {
      const checkboxes = this.checkedBoxes;
      const values = checkboxes().map((checkbox) => checkbox.value);
      this.fieldTree()().value.set([...values]);
    });
  }
  readonly label = input<string>();
  readonly labelTemplate = input<TemplateRef<{ $implicit: string }>>();
  readonly fieldTree = input.required<FieldTree<T[]>>();
  readonly checkboxes = input.required<Checkbox<T>[]>();
  readonly direction = input<'horizontal' | 'vertical'>('horizontal');

  checkedStateChanged = output<Checkbox<T>[]>();

  readonly fieldState = computed(() => this.fieldTree()());
  readonly name = computed(() => this.fieldState().keyInParent());
  readonly isValid = computed(() => this.fieldState().valid());
  readonly isDisabled = computed(() => this.fieldState().disabled());

  readonly checkedBoxes = computed(() =>
    this.checkboxes().filter((checkbox) => checkbox.checked()),
  );
}
